import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

const GA_ID = 'G-54TW191T1F';

function loadGA() {
  if (document.getElementById('ga-script')) return;
  const script = document.createElement('script');
  script.id = 'ga-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  const inline = document.createElement('script');
  inline.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_ID}');
  `;
  document.head.appendChild(inline);
}

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (consent === 'accepted') {
      loadGA();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    loadGA();
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem('cookie-consent', 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 z-[9999] bg-white border border-border rounded-2xl shadow-lg p-5 max-w-sm">
      <div className="flex flex-col items-start gap-3">
        <span className="text-3xl leading-none">🍪</span>
        <p className="text-sm text-muted-foreground">
          Ce site utilise des cookies pour améliorer votre expérience de navigation.
          Vous pouvez accepter ou refuser leur utilisation.
        </p>
        <div className="flex items-center gap-4">
          <button
            onClick={refuse}
            className="text-sm text-muted-foreground underline underline-offset-2 hover:text-foreground transition-colors"
          >
            Refuser
          </button>
          <Button size="sm" className="bg-rental-primary hover:bg-rental-primary/90 text-white" onClick={accept}>
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
